'use strict';

export default function chartConfig(scope) {
  'ngInject';

  let chartConfig = {
    chart: {
      height: 300,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    title: {text: '1日の電力消費実績'},
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      reversed: true
    },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      max: scope.categories.length - 1
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量 [kWh]'
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      formatter: function () {
        var tip_format = "<tspan style='font-size: 12px'>" + this.x + "</tspan>";

        angular.forEach(this.points, function (point, i) {
          tip_format += '<br/><span style="color:' + point.series.color + ';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + point.series.name + ': ';
          tip_format += point.y + " kWh";
          tip_format += "</span>"
        });

        return tip_format;
      }
    },
    series: [],
    plotOptions: {column: {grouping: true}}
  };
  return chartConfig;
}



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/active/daily/compare-graph-daily-active.config.js